
define('text!TescoMobile_DynamicBundleOptions/template/tenure-hint-modal.html',[],function () { return '<div id="tm-tenure-hint-modal-content" data-bind="afterRender: setModalElement"><div data-bind="html: tenureHintBlockContent"></div></div>';});

